import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
    typeOfIPAOptions,
    typeOfFAYearOptions,
    typeOfFAMAOptions,
    sectorOptions,
    typeOfAnnualOptions,
    typeOfProjectOptions
} from '../components/Enums';

export class ProjectKeyInformation extends Component {

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {

        //var typeOfAnnualOptions = [
        //    { TypeId: 1, TypeName: "Annual" },
        //    { TypeId: 2, TypeName: "Multi-Annual" }
        //];

        //var typeOfIPAOptions = [
        //    { TypeId: 1, TypeName: "IPA I" },
        //    { TypeId: 2, TypeName: "IPA II" },
        //    { TypeId: 3, TypeName: "IPA III" }
        //];

        //var typeOfFAYearOptions = [
        //    //{ TypeId: 2000, TypeName: "2000" },
        //    //{ TypeId: 2001, TypeName: "2001" },
        //    //{ TypeId: 2002, TypeName: "2002" },
        //    //{ TypeId: 2003, TypeName: "2003" },
        //    //{ TypeId: 2004, TypeName: "2004" },
        //    //{ TypeId: 2005, TypeName: "2005" },
        //    //{ TypeId: 2006, TypeName: "2006" },
        //    { TypeId: 2007, TypeName: "2007", IPATypeId: 1 },
        //    { TypeId: 2008, TypeName: "2008", IPATypeId: 1 },
        //    { TypeId: 2009, TypeName: "2009", IPATypeId: 1 },
        //    { TypeId: 2010, TypeName: "2010", IPATypeId: 1 },
        //    { TypeId: 2011, TypeName: "2011", IPATypeId: 1 },
        //    { TypeId: 2012, TypeName: "2012", IPATypeId: 1 },
        //    { TypeId: 2013, TypeName: "2013", IPATypeId: 1 },
        //    { TypeId: 2014, TypeName: "2014", IPATypeId: 2 },
        //    { TypeId: 2015, TypeName: "2015", IPATypeId: 2 },
        //    { TypeId: 2016, TypeName: "2016", IPATypeId: 2 },
        //    { TypeId: 2017, TypeName: "2017", IPATypeId: 2 },
        //    { TypeId: 2018, TypeName: "2018", IPATypeId: 2 },
        //    { TypeId: 2019, TypeName: "2019", IPATypeId: 2 },
        //    { TypeId: 2020, TypeName: "2020", IPATypeId: 2 },
        //    { TypeId: 2021, TypeName: "2021", IPATypeId: 3 },
        //    { TypeId: 2022, TypeName: "2022", IPATypeId: 3 },
        //    { TypeId: 2023, TypeName: "2023", IPATypeId: 3 },
        //    { TypeId: 2024, TypeName: "2024", IPATypeId: 3 },
        //    { TypeId: 2025, TypeName: "2025", IPATypeId: 3 },
        //    { TypeId: 2026, TypeName: "2026", IPATypeId: 3 },
        //    { TypeId: 2027, TypeName: "2027", IPATypeId: 3 },
        //    { TypeId: 2028, TypeName: "2028" },
        //    { TypeId: 2029, TypeName: "2029" },
        //    { TypeId: 2030, TypeName: "2030" },
        //    //{ TypeId: 2031, TypeName: "2031" },
        //    //{ TypeId: 2032, TypeName: "2032" },
        //    //{ TypeId: 2033, TypeName: "2033" },
        //    //{ TypeId: 2034, TypeName: "2034" },
        //    //{ TypeId: 2035, TypeName: "2035" },
        //    //{ TypeId: 2036, TypeName: "2036" },
        //    //{ TypeId: 2037, TypeName: "2037" },
        //    //{ TypeId: 2038, TypeName: "2038" },
        //    //{ TypeId: 2039, TypeName: "2039" },
        //    //{ TypeId: 2040, TypeName: "2040" },
        //    //{ TypeId: 2041, TypeName: "2041" },
        //    //{ TypeId: 2042, TypeName: "2042" },
        //    //{ TypeId: 2043, TypeName: "2043" },
        //    //{ TypeId: 2044, TypeName: "2044" },
        //    //{ TypeId: 2045, TypeName: "2045" },
        //    //{ TypeId: 2046, TypeName: "2046" },
        //    //{ TypeId: 2047, TypeName: "2047" },
        //    //{ TypeId: 2048, TypeName: "2048" },
        //    //{ TypeId: 2049, TypeName: "2049" },
        //    //{ TypeId: 2050, TypeName: "2050" }
        //];

        //var typeOfFAMAOptions = [
        //    { TypeId: 1, TypeName: "Multi-Annual 2007" },
        //    { TypeId: 2, TypeName: "Multi-Annual 2008" },
        //    { TypeId: 3, TypeName: "Multi-Annual 2009" },
        //    { TypeId: 4, TypeName: "Multi-Annual 2010" },
        //    { TypeId: 5, TypeName: "Multi-Annual 2011" },
        //    { TypeId: 6, TypeName: "Multi-Annual 2012" },
        //    { TypeId: 7, TypeName: "Multi-Annual 2013" },
        //    { TypeId: 8, TypeName: "Multi-Annual 2014" },
        //    { TypeId: 9, TypeName: "Multi-Annual 2015" },
        //    { TypeId: 10, TypeName: "Multi-Annual 2016" },
        //    { TypeId: 11, TypeName: "Multi-Annual 2017" },
        //    { TypeId: 12, TypeName: "Multi-Annual 2018" },
        //    { TypeId: 13, TypeName: "Multi-Annual 2019" },
        //    { TypeId: 14, TypeName: "Multi-Annual 2020" },
        //    { TypeId: 15, TypeName: "Multi-Annual 2021" },
        //    { TypeId: 16, TypeName: "Multi-Annual 2022" },
        //    { TypeId: 17, TypeName: "Multi-Annual 2023" },
        //    { TypeId: 18, TypeName: "Multi-Annual 2024" },
        //    { TypeId: 19, TypeName: "Multi-Annual 2025" },
        //    { TypeId: 20, TypeName: "Multi-Annual 2026" },
        //    { TypeId: 21, TypeName: "Multi-Annual 2027" },
        //    { TypeId: 22, TypeName: "Multi-Annual 2028" },
        //    { TypeId: 23, TypeName: "Multi-Annual 2029" },
        //    { TypeId: 24, TypeName: "Multi-Annual 2030" },
        //];

        //var sectorOptions = [
        //    { TypeId: 1, TypeName: "Civil Society" },
        //    { TypeId: 2, TypeName: "Judiciary" },
        //    { TypeId: 3, TypeName: "Fundamental Rights" },
        //    { TypeId: 4, TypeName: "Home Affairs" },
        //    { TypeId: 5, TypeName: "Environment and Climate Action" },
        //    { TypeId: 6, TypeName: "Transport" },
        //    { TypeId: 7, TypeName: "Energy" },
        //    { TypeId: 8, TypeName: "Competitiveness and Innovation" },
        //    { TypeId: 9, TypeName: "Employment, Human Resources Development and Social Policies" },
        //    { TypeId: 10, TypeName: "Agriculture and Rural Development – Institution and Capacity Building" },
        //    { TypeId: 11, TypeName: "RRAA-Standalone Projects" },
        //];

        //var typeOfProjectOptions = [
        //    { TypeId: 1, TypeName: "Direct Grant" },
        //    { TypeId: 2, TypeName: "Grant" },
        //    { TypeId: 3, TypeName: "Service" },
        //    { TypeId: 4, TypeName: "Twinning" },
        //    { TypeId: 5, TypeName: "Supply" },
        //    { TypeId: 6, TypeName: "Works" },
        //    { TypeId: 7, TypeName: "Other" },
        //];

        //var smcsOptions = [
        //    { TypeId: 1, TypeName: "SMSC - 1 (Political Criteria)" },
        //    { TypeId: 2, TypeName: "SMSC - 2 (Justice, Freedom and Security)" },
        //    { TypeId: 3, TypeName: "SMSC - 3 (Civil Society Dialogue)" },
        //    { TypeId: 4, TypeName: "SMSC - 4 (Internal Market & Customs Union, Energy)" },
        //    { TypeId: 5, TypeName: "SMSC - 5 (Public Finance, Statistics and APS)" },
        //    { TypeId: 6, TypeName: "SMSC - 6 (Cross Border Cooperation)" },
        //    { TypeId: 7, TypeName: "SMSC - 7 (Environment)" },
        //    { TypeId: 8, TypeName: "SMSC - 8 (Regional Development, Transport)" },
        //    { TypeId: 9, TypeName: "SMSC - 9 (Human Resource Development)" },
        //    { TypeId: 10, TypeName: "SMSC - 10 (Rural Development)" },
        //];

        const {
            onChange,
            onSelectChange,
            typeOfProject,
            sector,
            //smcsCode,
            annualType,
            IPAType,
            FAType,
            FAMAType,
            userType,
        } = this.props;

        return (
            <Card>
                <CardHeader title="Project Key Information" className='romis-card-header' />
                <CardContent>

                    <Autocomplete
                        options={typeOfIPAOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "IPAType")}
                        value={this.returnArrayElement(typeOfIPAOptions, IPAType)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="IPA Type"
                                placeholder="IPA Type"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />

                    <Autocomplete
                        options={sectorOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "sector")}
                        value={this.returnArrayElement(sectorOptions, sector)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Sector"
                                placeholder="Sector"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />

                    <Autocomplete
                        options={typeOfAnnualOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "annualType")}
                        value={this.returnArrayElement(typeOfAnnualOptions, annualType)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Annual Type"
                                placeholder="Annual Type"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />

                    <Autocomplete
                        options={typeOfFAYearOptions.filter(obj => obj.IPATypeId == IPAType)}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "FAType")}
                        value={this.returnArrayElement(typeOfFAYearOptions, FAType)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Financing Agreement (Annual)"
                                placeholder="Financing Agreement (Annual)"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        style={{ display: annualType === 1 ? "block" : "none" }}
                        disabled={userType !== 2 ? true : false}
                    />

                    <Autocomplete
                        options={typeOfFAMAOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "FAMAType")}
                        value={this.returnArrayElement(typeOfFAMAOptions, FAMAType)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Financing Agreement (Multi-Annual)"
                                placeholder="Financing Agreement (Multi-Annual)"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        style={{ display: annualType === 2 ? "block" : "none" }}
                        disabled={userType !== 2 ? true : false}
                    />

                    <Autocomplete
                        options={typeOfProjectOptions}
                        getOptionLabel={option => option.TypeName}
                        autoComplete
                        includeInputInList
                        onChange={(e, v) => onSelectChange(e, v, "typeOfProject")}
                        value={this.returnArrayElement(typeOfProjectOptions, typeOfProject)}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Type of Project / Contract"
                                placeholder="Type of Project / Contract"
                                fullWidth
                                margin="normal"
                            />
                        )}
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                        //    label="Sector :"
                        //    placeholder="Sector"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={sector}
                        //    name="sector"
                        ///>
                    }

                    {
                        //<TextField
                        //    label="SMSC Code :"
                        //    placeholder="SMSC Code"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={smcsCode}
                        //    name="smcsCode"

                        ///>
                    }

                    {
                        //<Autocomplete
                        //    options={smcsOptions}
                        //    getOptionLabel={option => option.TypeName}
                        //    autoComplete
                        //    includeInputInList
                        //    onChange={(e, v) => onSelectChange(e, v, "smcsCode")}
                        //    value={this.returnArrayElement(smcsOptions, smcsCode)}
                        //    renderInput={params => (
                        //        <TextField
                        //            {...params}
                        //            label="SMSC Code"
                        //            placeholder="SMSC Code"
                        //            fullWidth
                        //            margin="normal"
                        //        />
                        //    )}
                        ///>
                    }

                </CardContent>
            </Card>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/ProjectKeyInformation.js